module.exports = __webpack_public_path__ + "img/right_angle_corner_icon.54f0823e.svg";